import { AUTO_KIT_TYPE } from 'shared/kit';
import { commonPlaceholder } from 'modules/overlay-canvas/types/placeholders/create-argument';

interface IItem extends commonPlaceholder {
  listName: string;
}

export const commonPlaceholderList: IItem[] = [
  {
    listName: 'Город',
    indicator: 'city',
    blockText: 'Город',
    type: 'text',
  },
  {
    listName: 'Логотип турнира',
    indicator: 'organizerLogo',
    blockText: 'Логотип турнира',
    type: 'image',
  },
  {
    listName: 'Название чемпионата',
    indicator: 'championshipName',
    blockText: 'Название чемпионата',
    type: 'text',
  },
  {
    listName: 'Время начала матча',
    indicator: 'startMatchTime',
    blockText: 'Время начала матча',
    type: 'text',
  },
  {
    listName: 'Дата начала матча',
    indicator: 'startMatchDate',
    blockText: 'Дата начала матча',
    type: 'text',
  },
  {
    listName: 'Время матча',
    indicator: 'matchTime',
    blockText: 'Время матча',
    type: 'text',
  },
  {
    listName: 'Логотип\nкоманды',
    indicator: 'teamLogo',
    blockText: 'Логотип команды',
    type: 'image',
    teamIndex: 0,
  },
  {
    listName: 'Форма\nкоманды',
    indicator: 'teamKit',
    blockText: 'Форма команды',
    type: 'image',
    teamIndex: 0,
    kitType: AUTO_KIT_TYPE,
    kitElements: 'full',
  },
  {
    listName: 'Название команды',
    indicator: 'teamName',
    blockText: 'Название команды',
    type: 'text',
    teamIndex: 0,
  },
  {
    listName: 'Короткое название\nкоманды',
    indicator: 'teamShortName',
    blockText: 'Короткое название команды',
    type: 'text',
    teamIndex: 0,
  },
  {
    listName: 'Счёт команды',
    indicator: 'teamScore',
    blockText: 'Счёт команды',
    type: 'text',
    teamIndex: 0,
  },
  {
    listName: 'Фолы команды',
    indicator: 'teamFouls',
    blockText: 'Фолы команды',
    type: 'text',
    teamIndex: 0,
  },
  // Индикаторы намеренно не совпадают с событийными `teamShootoutGoals`/`teamShootoutMisses`:
  // те ищутся по `teamReverse` и живут только в карточке события, эти — по `teamIndex`
  // и держатся на табло всю серию.
  {
    listName: 'Счёт серии пенальти',
    indicator: 'teamShootoutScore',
    blockText: 'Счёт серии пенальти',
    type: 'text',
    teamIndex: 0,
  },
  {
    listName: 'Промахи в серии\nпенальти',
    indicator: 'teamShootoutMissCount',
    blockText: 'Промахи в серии пенальти',
    type: 'text',
    teamIndex: 0,
  },
  {
    listName: 'Тайм',
    indicator: 'period',
    blockText: 'Тайм',
    type: 'text',
  },
];
